import { render, staticRenderFns } from "./shop2.vue?vue&type=template&id=2d40b7fd&scoped=true&"
import script from "./shop2.vue?vue&type=script&lang=js&"
export * from "./shop2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d40b7fd",
  null
  
)

export default component.exports